<template ref="main">
    <div class="c-flexible-forms-v2 -theme-color-white" :class="{ '-with-stepper': useStepper }" :data-component-name="$options.name">
        <div class="o-grid -y-0">

            <div class="-mobile-steps__counter" v-if="useStepper">
                <span v-if="useStepper && form.currentStep + 1 < stepperSections.length">
                    {{ form.currentStep + 1 }} / {{ stepperSections.length }}
                </span>
                <span v-else-if="useStepper && form.currentStep + 1 == stepperSections.length">
                    {{ form.currentStep + 1 }} / {{ stepperSections.length }}
                </span>
            </div>

            <div :class="{
                'o-grid-8 o-form-left': useStepper,
                'o-grid-12': !useStepper,
            }">

                <div
                    class='o-form-response -error'
                    v-if="limitReached"
                >
                    <div class="o-form-response__inner">
                        <!-- <div class="o-form-response__icon">
                            <svgIco icon="active" v-if="result.status === 'success'"></svgIco>
                        </div> -->
                        <div class="o-text">
                            <div class="o-form-response__text" v-html="settings.formLimitResultsMessage.value"></div>
                        </div>
                    </div>
                </div>
                <div
                    :class="{
                        'o-form-response -error': result.status === 'error',
                        'o-form-response -success': result.status === 'success',
                        'o-form-response -loading': result.loading === true,
                    }"
                    v-else-if="result.status !== null || result.loading === true"
                >
                    <div class="o-form-response__inner">
                        <!-- <div class="o-form-response__icon">
                            <svgIco icon="active" v-if="result.status === 'success'"></svgIco>
                        </div> -->
                        <div class="o-text">
                            <div class="o-form-response__text" v-html="(result.loading == true) ? $root.nl2br(loadingMessage) : $root.nl2br(result.message)"></div>
                            <div class="o-form-response__text" v-if="result.hashedURL">
                                <p>
                                    {{ _t('L\'URL de récupération vous a été envoyée par courriel. Vous pouvez reprendre le formulaire à tout moment.') }}
                                </p>
                                <a :href="result.hashedURL" class="o-button -link">
                                    {{ _t('Reprendre le formulaire dès maintenant') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <form
                    action=""
                    class="o-form o-flexible-form o-form-styled"
                    :class="{
                        'is-form-success-ready': result.status === 'success',
                        'is-form-error-ready': result.status === 'error',
                        'is-form-hidden': formHideOnSuccess && result.status === 'success',
                        'is-form-disabled': (isFormDisabled || limitReached),
                    }"
                    :ref="'form-'+form.id"
                    @change="formChanged=true"
                    @input="formChanged=true"
                >
                    <input type="hidden" name="formShortUUID" :value="formShortID">
                    <input type="hidden" name="formUUID" :value="form.id">
                    <input type="hidden" name="Langue" :value="currentlanguage">

                    <div class="o-form__sections__wrapper">
                        <FormSection 
                            v-for="(section, si) in activeSections"
                            :key="section.id"
                            :ref="section.id"
                            :id="section.id"
                            :section="section"
                            :currentStep="form.currentStep"
                            :totalSteps="activeSections.length"
                            :disabledIDs="disabledIDs"
                        />

                        <small class="form-id">{{ '#' + formShortID }}</small>

                        <div class="o-form__item o-flex -flex-gap-xs -flex-end -flex-w-100p">
                            <div class="-mobile-steps">
                                <button ref="prevButton" type="button" class="o-button -icon-reverse" @click="form.currentStep--;saveForm({ userEmail: null, userPhone: null, autoSave: true })" :disabled="useStepper && form.currentStep <= 0" v-if="stepperSections.length>1">
                                    <span class="o-button__ico">
                                        <svg class="o-ico icon-arrow-right-full" aria-hidden="true" role="img">
                                            <use xlink:href="/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#arrow-left"></use>
                                        </svg>
                                    </span>
                                    <span class="o-button__text">
                                        <span class="o-button__text__elm">
                                            {{ _t('Précédent') }}
                                        </span>
                                    </span>
                                </button>

                                <div class="o-form__tools" v-if="useStepper">
                                    <!-- <a 
                                    class="o-button -no-border" 
                                    href="tel:+18006623313" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    aria-label="Ouvre dans une nouvelle fenêtre"
                                    :class="{'disabled' : showSaveModal == true}"
                                    >
                                        <span class="o-button__text">
                                            <span class="o-button__text__elm">
                                                {{ _t('Aide ?') }}
                                            </span>
                                        </span>
                                        <span class="o-button__ico">
                                            <svg class="o-ico" aria-hidden="true" role="img">
                                                <use xlink:href="/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#phone"></use>
                                            </svg>
                                        </span>
                                    </a> -->

                                    <button 
                                    v-if="allowRecovery === true && result.status !== 'success'" 
                                    class="o-button -no-border" type="button" 
                                    @click="showSaveModal=true" 
                                    >
                                        <span class="o-button__text">
                                            <span class="o-button__text__elm">
                                                {{ _t('Sauvegarder') }}
                                            </span>
                                        </span>
                                        <!-- <span class="o-button__ico">
                                            <svg class="o-ico" aria-hidden="true" role="img">
                                                <use xlink:href="/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#save"></use>
                                            </svg>
                                        </span> -->
                                    </button>
                                </div>
                        
                                <button ref="nextButton" type="button" class="o-button" @click="validateForm(form.currentStep);saveForm({ userEmail: null, userPhone: null, autoSave: true })" :disabled="useStepper && form.currentStep + 1 >= stepperSections.length"
                                    v-if="activeSections.length > 1 && form.currentStep + 1 < stepperSections.length"
                                >
                                    <span class="o-button__text">
                                        <span class="o-button__text__elm">
                                            {{ _t('Suivant') }}
                                        </span>
                                    </span>
                                    <span class="o-button__ico">
                                        <svg class="o-ico icon-arrow-right-full" aria-hidden="true" role="img">
                                            <use xlink:href="/assets/img/sprite.svg?v=eb7dc8822a82d06af9634180#arrow-right"></use>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <button ref="submitButton" type="button" class="o-button -button-text -submit-form" @click="submitForm()" v-if="!useStepper || form.currentStep + 1 == stepperSections.length">
                                <span class="o-button__text">
                                    <span class="o-button__text__elm" v-html="submitLabel">
                                    </span>
                                </span>
                                <span class="o-button__icos">
                                    <span class="o-button__ico">
                                        <svgIco icon="arrow-full-right" class="o-ico -ico-arrow-full-right"></svgIco>
                                    </span>
                                    <span class="o-button__ico">
                                        <svgIco icon="arrow-full-right" class="o-ico -ico-arrow-full-right"></svgIco>
                                    </span>
                                </span>
                            </button>

                        </div>
                    </div>

                </form>

            </div>

            <FormStepper
                class="o-grid-4 sm:4 o-form-right"
                v-if="useStepper"
                :sections="stepperSections"
                :currentStep="form.currentStep"
                :result="result"
                :allowRecovery="allowRecovery"
                :showSaveModal="showSaveModal"
                @show-save-modal="showSaveModal=$event"
                @save-for-later="saveForm($event)"
                @go-to-step="form.currentStep=$event"
                :formIsCompleted="formIsCompleted"
            />
        </div>
        <FormRecoverModal 
            v-if="showRecoverModal"
            @close-modal="showRecoverModal=false"
            :entryID="entry.id"
            :siteID="entry.siteId"
            :form="form"
        />
        <!-- Assistant de traduction - décommenté au besoin en dev -->
        <div v-if="enabletranslationsassistant" style="margin-top: 16px">
            <small style="color: var(--color-gray); cursor: pointer;" @click="translationsAssistantActive = !translationsAssistantActive">Afficher l'assistant de traduction<br>(administrateur seulement)</small>
            
            <div v-if="translationsAssistantActive">
                {{ $root.currentlanguage }}
                <textarea v-if="translationsAssistantActive" rows="60" class="o-input" style="display:none11" ref="stringTranslations">{{ JSON.stringify($root.translationsString, null, 4) }}</textarea>
            </div>
        </div>

        <!-- <pre>{{ settings.formConsentMessageReason }}</pre>
        <pre>{{ activeSections }}</pre> -->

    </div>
</template>

<script>

    import { v4 as uuidv4 } from 'uuid'

    export default {
        name: 'Form',
        props: {
            blocks:{
                type: Array,
                default() {
                    return []
                }
            },
            settings:{
                type: Object,
                default() {
                    return {}
                }
            },
            entry:{
                type: [Object, Array, String],
                default() {
                    return {}
                }
            },
            translationsstring:{
                type: Object,
                default() {
                    return {}
                }
            },
            currentlanguage:{
                type: String,
                default: 'fr-CA'
            },
            spriteurl:{
                type: String,
                default() {
                    return ''
                }
            },
            fieldhandle: {
                type: String,
                default() {
                    return ''
                }
            },
            recaptcha: {
                type: [String, Boolean],
                default: false
            },
            limitReached: {
                type: Boolean,
                default: false
            },
            canadapostapikey: {
                type: String,
                default: ''
            },
            enabletranslationsassistant: {
                type: Boolean,
                default: false
            },
            parententryid: {
                type: Number,
                default: null
            },
        },
        data(){
            return {
                result: {
                    status: null,
                    message: null,
                    hashedURL: null,
                    loading: false,
                },
                autoSectionIndex: 0,
                form: {
                    id: uuidv4(),
                    currentStep: null,
                    sections: [],
                },
                stepperSections: [],
                loadingMessage: (this.settings?.formWaitMessage?.value != '') ? this.settings.formWaitMessage.value : this._t('S.V.P. patientez....'),
                formHideOnSuccess: (this.settings?.formHideOnSuccess?.value === true) ? true : false,
                submitLabel: (this.settings?.formButton?.value != '') ? this.settings.formButton.value : this._t('Envoyer'),
                allowRecovery: (this.settings?.allowRecovery?.value === true) ? true : false,
                showSaveModal: false,
                isFormDisabled: false,
                showRecoverModal: false,
                formIsCompleted: false,
                formChanged: false,
                translationsAssistantActive: false,
                syncedFields: [],
                submitDebounce: null,
            }
        },
        mounted() {

            this.$nextTick(() => {
                this.form.currentStep = 0
            })

            this.$root.canadaPost_APIKey = this.canadapostapikey
            if (typeof this.translationsstring === 'object' && !Array.isArray(this.translationsstring) && this.translationsstring !== null) {
                this.$root.translationsString = this.translationsstring
            } else this.$root.translationsString = {}
            this.$root.currentlanguage = this.currentlanguage

            let url = new URL(window.location)
            window.addEventListener('beforeunload', function (e) {
                if (this.formChanged && this.result.status !== 'success') {
                    e.preventDefault();
                    e.returnValue = '';
                }
            }.bind(this));

            let recover = url.searchParams.get('recover');
            if(recover) {
                this.showRecoverModal = true;
            }


            this.$root.spriteURL = this.spriteurl

            let section = null
            let stepIndex = -1
            let withSteps = false
            this.blocks.forEach((block, index) => {

                if (block.fieldsList) {
                    block.fieldsList.forEach(field => {
                        if (typeof field.value == 'undefined' && field.inputName) {
                            field.value = (field.inputDefaultValue) ? field.inputDefaultValue : null;
                        }
                        if (typeof field.inputAutocomplete != 'undefined' && field.inputAutocomplete == 'querystring' && 
                            typeof field.inputValueFromQS != 'undefined' && String(field.inputValueFromQS).trim() != '' &&
                            (typeof field.value == 'undefined' || field.value == null || String(field.value).trim() == '') &&
                            url.searchParams.has(field.inputValueFromQS)
                        ) {
                            if(String(url.searchParams.get(field.inputValueFromQS)).trim()!="") field.value = url.searchParams.get(field.inputValueFromQS);
                        }
                        if (typeof field.inputAutocomplete != 'undefined' && field.inputAutocomplete == 'cookie' && 
                            typeof field.inputValueFromQS != 'undefined' && String(field.inputValueFromQS).trim() != ''
                        ) {
                            let cookie = document.cookie.match(new RegExp('(^| )' + field.inputValueFromQS + '=([^;]+)'));
                            if (cookie) field.value = cookie[2];
                        }
                    })
                    if (block.groupIsRepeater && block.groupIsRepeater === true && !block.initialFieldsList) {
                        block.initialFieldsList = JSON.parse(JSON.stringify(block.fieldsList))
                        block.fieldsList = []
                    }
                }

                if (!this.form.sections.length && block.type != 'FormSection') {
                    this.autoSectionIndex++
                    section = {
                        id: 'auto-section-' + this.autoSectionIndex,
                        isStep: false,
                        stepIndex: -1,
                        conditionalLogic: false,
                        label: 'section automatique' + this.autoSectionIndex,
                        name: 'section-automatique' + this.autoSectionIndex,
                        title: null,
                        fields: [block],
                    }
                    this.form.sections.push(section)
                    return
                }

                if (block.type == 'FormSection') {
                    if (!section || section.id != block.id) {
                        section = {
                            id: 'section-'+block.id,
                            isStep: block.formSectionIsStep,
                            isSubStep: block.formSectionIsStep && block.formSectionIsSubStep,
                            scriptOnEnter: (block.formSectionScriptOnEnter && block.formSectionScriptOnEnter != null && String(block.formSectionScriptOnEnter).trim()!='') ? block.formSectionScriptOnEnter : false,
                            scriptOnLeave: (block.formSectionScriptOnLeave && block.formSectionScriptOnLeave != null && String(block.formSectionScriptOnLeave).trim()!='') ? block.formSectionScriptOnLeave : false,
                            stepIndex: -1,
                            conditionalLogic: (block.conditionalLogic) ? block.conditionalLogic : false,
                            label: (block.label && block.label != '') ? block.label : block.name,
                            name: block.name,
                            title: (block.formSectionTitle && block.formSectionTitle != '') ? block.formSectionTitle : null,
                            fields: (block.fields) ? block.fields : [],
                        }

                        if (section.isStep === true) {
                            section.stepIndex = ++stepIndex
                        }

                        if (block.formSectionIsStep) withSteps = true
                    }
                    this.form.sections.push(section)
                    return
                }

                if (section) {
                    section.fields.push(block)
                }

            })

            if (this.settings.formConsentMessageReason && this.settings.formConsentMessageReason.value !='') {
                this.autoSectionIndex++
                let section = {
                    id: 'auto-section-' + this.autoSectionIndex,
                    isStep: withSteps,
                    stepIndex: this.form.sections.length,
                    conditionalLogic: false,
                    label: 'section consent' + this.autoSectionIndex,
                    name: 'section-consent' + this.autoSectionIndex,
                    title: this._t('Consentement'),
                    fields: [{
                        id: new uuidv4(),
                        name: this._t('Consentement'),
                        "slug": "formFieldsGroup",
                        "type": "FormFieldsGroup",
                        fieldsList: [
                            {
                                "enabled": true,
                                "id": new uuidv4(),
                                "inputName": "Message",
                                "inputType": "message",
                                "inputMessage": this.settings.formConsentMessageReason.message,
                                "inputClass": "o-grid-12",
                                "value": null
                            },
                            {
                                "enabled": true,
                                "id": new uuidv4(),
                                "inputLabel": '<strong>'+this._t("Consentement à la collecte et à l’utilisation de vos renseignements personnels")+'</strong>',
                                "inputRequired": true,
                                "inputReadonly": false,
                                "inputName": "consentement_confirmation",
                                "inputPlaceholder": "",
                                "inputType": "checkbox",
                                "inputAutocomplete": "off",
                                "inputChoices": [
                                    {
                                        "text": this._t("En cochant, je confirme avoir pris connaissance et avoir compris l'information contenue aux présentes relativement à la collecte et à l'utilisation de mes renseignements personnels et je consens à l'utilisation et à la communication de mes renseignements personnels telle que prévue au présent formulaire. Je certifie avoir pris connaissance des instructions qui accompagnent le présent formulaire. Je déclare que, au meilleur de ma connaissance, les renseignements donnés ci-dessus sont exacts et complets."),
                                        "value": "oui-consentement",
                                        "picto": "",
                                        "default": false
                                    }
                                ],
                                "inputClass": "o-grid-12",
                                "inputChoicesButtonStyle": false,
                                "inputInstructions": "",
                                "inputTooltip": "",
                                "value": null
                            },
                            {
                                "enabled": true,
                                "id": new uuidv4(),
                                "inputRequired": true,
                                "inputReadonly": false,
                                "inputName": "consentement_message_consenti",
                                "inputPlaceholder": "",
                                "inputType": "hidden",
                                "inputAutocomplete": "off",
                                "inputClass": "o-grid-6",
                                "inputInstructions": "",
                                "inputTooltip": "",
                                "value": this.settings.formConsentMessageReason.message
                            }


                        ]
                    }],
                }
                this.form.sections.push(section)
            }

            this.form.sections.forEach(section => {
                section.fields.forEach(fields => {
                    if (!section.fieldsList) return;
                    fields.fieldsList.forEach(field => {
                        if (typeof field.inputAutocomplete != 'undefined' && field.inputAutocomplete == 'reactivevalue' && 
                            typeof field.inputValueFromField != 'undefined' && String(field.inputValueFromField).trim() != ''
                        ) {
                            let refField = this.getFieldByID(field.inputValueFromField)
                            if (refField) {
                                refField.syncTarget = field
                                this.syncedFields.push(refField)
                            }
                        }
                    })
                })
            })
            this.getStepperSections()

            this.emitter.on('set-form-value', this.setFormValue)
            this.emitter.on('get-mapped-hidden-field', this.getMappedHiddenField)

        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeUnload);
        },
        computed: {

            section() {
                return this.activeSections[this.form.currentStep];
            },
            totalSteps() {
                return this.activeSections.length;
            },
            currentStep() {
                return this.form.currentStep;
            },

            formShortID() {
                return this.form.id.split('-').pop()
            },

            useStepper() {
                return this.stepperSections.length > 1
            },

            activeSections() {
                let activeSections = []
                if (!this.form.sections.length) return activeSections
                activeSections = this.form.sections.filter(section => !this.disabledIDs.includes(section.id))
                let si = -1
                let stepIndexLabel = 0
                let subStepIndexLabel = 0
                activeSections.map((section) => {
                    if (section.isStep && !section.isSubStep) {
                        stepIndexLabel++
                        si++
                        section.stepIndexLabel = stepIndexLabel
                        section.stepIndex = si
                        subStepIndexLabel = 0
                    }
                    if (section.isStep && section.isSubStep) {
                        subStepIndexLabel++
                        si++
                        section.stepIndex = si
                        section.stepIndexLabel = String(stepIndexLabel)+'.'+String(subStepIndexLabel)
                    }
                })


                return activeSections
            },

            activeFields() {
                let activeFields = []
                if (!this.form.sections.length) return activeFields
                this.form.sections.forEach(section => {
                    section.fields.forEach(fields => {
                        if (fields.groupIsRepeater && fields.groupIsRepeater === true) {
                            fields.fieldsList.forEach(fieldl => {
                                fieldl.forEach(field => {
                                    activeFields.push({
                                        name: field.inputName,
                                        id: field.id,
                                        value: field.value,
                                    })
                                })
                            })
                        } else if (fields.fieldsList) {
                            fields.fieldsList.forEach(field => {
                                activeFields.push({
                                    name: field.inputName,
                                    id: field.id,
                                    value: field.value,
                                })
                            })
                        }
                    })
                })
                return activeFields
            },
        
            disabledIDs() {
                let disabledIDs = []
                if (!this.form.sections.length) return disabledIDs
                this.form.sections.forEach(section => {

                    if (section.conditionalLogic) {
                        if (!this.validateConditionalRule(section.conditionalLogic)) disabledIDs.push(section.id)
                    }

                    section.fields.forEach(fields => {
                        if (fields.conditionalLogic) {
                            if (!this.validateConditionalRule(fields.conditionalLogic)) disabledIDs.push(fields.id)
                        }

                        if (!fields.fieldsList) return

                        if (fields.groupIsRepeater && fields.groupIsRepeater === true) {
                            fields.fieldsList.forEach(fieldl => {
                                fieldl.forEach(field => {
                                    if (field.conditionalLogic) {
                                        if (!this.validateConditionalRule(field.conditionalLogic, field)) disabledIDs.push(field.id)
                                    }
                                })
                            })
                        } else {

                            fields.fieldsList.forEach(field => {
                                if (field.conditionalLogic) {
                                    if (!this.validateConditionalRule(field.conditionalLogic, field)) disabledIDs.push(field.id)
                                }
                            })
                        }
                    })
                })
                return disabledIDs
            },
        },
        watch: {

            syncedFields: {
                handler: function (val, oldVal) {
                    this.syncedFields.forEach(field => {
                        if (field.syncTarget) {
                            field.syncTarget.value = field.value
                        }
                    })
                },
                deep: true
            },

            'result.loading': {
                handler: function (val, oldVal) {
                    this.$el.querySelectorAll('input, textarea, select, fieldset, button').forEach(input => {
                        input.disabled = (val === true) ? 'disabled' : false
                    })
                    this.isFormDisabled = (val === true) ? true : false
                }
            },

            'result.status': {
                handler: function (val, oldVal) {
                    let disabled = (val === 'success') ? true : false

                    this.$el.querySelectorAll('input, textarea, select, fieldset, button').forEach(input => {
                        input.disabled = (disabled === true) ? 'disabled' : false
                    })
                    this.isFormDisabled = disabled
                }
            },
            
            showSaveModal: {
                handler: function (val, oldVal) {
                    this.$el.querySelectorAll('input, textarea, select, fieldset, button').forEach(input => {
                        input.disabled = (val === true) ? 'disabled' : false
                    })
                    this.isFormDisabled = (val === true) ? true : false
                }
            },

            'form.currentStep': {
                handler: function (val, oldVal) {
                    let headerHeight = 0;
                    if (this.$el.querySelector('.c-mobile-stepper__wrap')) headerHeight = headerHeight + this.$el.querySelector('.c-mobile-stepper__wrap').offsetHeight
                    if (document.querySelector('header')) headerHeight = headerHeight + document.querySelector('header').offsetHeight

                    window.locomotiveScroll.scrollTo(this.$el, {
                        offset: parseInt('-' + (headerHeight + 60))
                    })
                    this.$nextTick(() => {
                        if (this.$refs.submitButton) this.$refs.submitButton.blur()
                        if (this.$refs.prevButton) this.$refs.prevButton.blur()
                        if (this.$refs.nextButton) this.$refs.nextButton.blur()
                    })
                }
            },

            'form': {
                handler: function (val, oldVal) {
                    this.getStepperSections()
                    this.$root.form = val
                    if (this.form.currentStep + 1 > this.stepperSections.length) this.form.currentStep = this.stepperSections.length - 1
                },
                deep: true
            },

        },
        methods: {

            saveForm(event, recaptchaToken=null) {

                let headerHeight = 0;
                if (this.$el.querySelector('.c-mobile-stepper__wrap')) headerHeight = headerHeight + this.$el.querySelector('.c-mobile-stepper__wrap').offsetHeight
                if (document.querySelector('header')) headerHeight = headerHeight + document.querySelector('header').offsetHeight

                if (!event.autoSave) {
                    window.locomotiveScroll.scrollTo(this.$el, {
                        offset: parseInt('-' + (headerHeight + 60)),
                        duration: 0
                    })
                }

                this.result = {
                    loading: (event.autoSave) ? false : true,
                    status: null,
                    message: null,
                    hashedURL: null,
                }


                if (!this.$root.session) {
                    this.$root.getSessionInfo().then((session) => {
                        this.saveForm(event);
                    });
                    return
                }

                if (this.recaptcha && recaptchaToken === null) {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(this.recaptcha, { action: 'submit' }).then((token) => {
                            this.saveForm(event, token);
                        });
                    });
                    return
                }


                let headers = {
                    'Accept': 'application/json',
                    'X-CSRF-Token': this.$root.session.csrfTokenValue,
                    'X-Requested-With': 'XMLHttpRequest',
                };

                let formData = new FormData();
                formData.append('userEmail', event.userEmail);
                formData.append('userPhone', event.userPhone);
                formData.append('autoSave', (event.autoSave) ? true : false);
                formData.append('parententryid', this.parententryid);
                formData.append('form', JSON.stringify(this.form));

                fetch('/flexibleform/save/' + this.entry.siteId + '/' + this.entry.canonicalId + '/' + this.fieldhandle + '/' + this.form.id, {
                    method: 'POST',
                    headers: headers,
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    this.submitForm(null, true)
                    if (event.autoSave) return
                    
                    this.result = {
                        loading: false,
                        status: data.status,
                        message: data.message,
                        hashedURL: null,
                    }
                    if(data.status=="success"){
                        this.showSaveModal = false
                        if(data.hashedURL) {
                            this.result.hashedURL = data.hashedURL
                        }

                        if (this.settings.GTMonSave?.value != null && String(this.settings.GTMonSave.value).trim() != '') {
                            try {
                                eval(this.settings.GTMonSave.value)
                            } catch (error) {
                                console.error('Error:', error)
                            }
                        }

                    }else{
                        this.showSaveModal = true
                        this.result.status= 'error'
                    }
                })
                .catch((error) => {
                
                    console.error('Error:', error)
                    if (event.autoSave) return

                    this.result = {
                        loading: false,
                        status: 'error',
                        message: error,
                    }
                    this.showSaveModal = true

                })
                .finally(() => {
                    this.result.loading = false
                })

            },

            submitForm(recaptchaToken = null, partialForm = false) {

                if (this.limitReached) {
                    return
                }

                let submitDelay = 100

                if (partialForm) {
                    submitDelay = 3000
                }

                if (this.submitDebounce) {
                    clearTimeout(this.submitDebounce)
                }
                this.submitDebounce = setTimeout(() => {

                    if (!partialForm) {
                        let headerHeight = 0;
                        if (this.$el.querySelector('.c-mobile-stepper__wrap')) headerHeight = headerHeight + this.$el.querySelector('.c-mobile-stepper__wrap').offsetHeight
                        if (document.querySelector('header')) headerHeight = headerHeight + document.querySelector('header').offsetHeight

                        window.locomotiveScroll.scrollTo(this.$el, {
                            offset: parseInt('-' + (headerHeight + 60)),
                            duration: 0
                        })

                        this.result = {
                            loading: this.validateForm(),
                            status: null,
                            message: null,
                            hashedURL: null,
                        }
                        this.formIsCompleted = false

                        if (!this.result.loading) return
                    }


                    if (!this.$root.session) {
                        this.$root.getSessionInfo().then((session) => {
                            this.submitForm(recaptchaToken, partialForm);
                        });
                        return
                    }

                    if (this.recaptcha && recaptchaToken === null) {
                        grecaptcha.ready(() => {
                            grecaptcha.execute(this.recaptcha, { action: 'submit' }).then((token) => {
                                this.submitForm(token, partialForm);
                            });
                        });
                        return
                    }


                    let headers = {
                        'Accept': 'application/json',
                        'X-CSRF-Token': this.$root.session.csrfTokenValue,
                        'X-Requested-With': 'XMLHttpRequest',
                    };

                    let formData = new FormData()
                    formData.append('Submission_is_complete', !partialForm)

                    this.$el.querySelectorAll('input, textarea, select').forEach(function (item) {
                        if ((item.type == 'checkbox' || item.type == 'radio') && !item.checked) return

                        if (item.type == 'file') {
                            for (let i = 0; i < item.files.length; i++) {
                                formData.append(item.name, item.files[i]);
                            }
                        } else {
                            formData.append(item.name, item.value)
                        }
                    })


                    fetch('/flexibleform/submit/' + this.entry.siteId + '/' + this.entry.canonicalId + '/' + this.fieldhandle + '/' + this.form.id, {
                        method: 'POST',
                        headers: headers,
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (partialForm) return

                        this.result = {
                            loading: false,
                            status: data.status,
                            message: data.message,
                        }
                        // this.isFormDisabled = data.limitReached
                        if (data.status == "success") {
                            this.formIsCompleted = true
                            let url = new URL(window.location)
                            url.searchParams.append('sent', this.form.id);
                            history.replaceState(null, '', url);

                            if (this.settings.GTMonSubmit?.value != null && String(this.settings.GTMonSubmit.value).trim() != '') {
                                try {
                                    eval(this.settings.GTMonSubmit.value)
                                } catch (error) {
                                    console.error('Error:', error)
                                }
                            }
                        }
                    })
                    .catch((error) => {
                    
                        console.error('Error:', error)
                        if (partialForm) return

                        this.result = {
                            loading: false,
                            status: 'error',
                            message: error,
                        }
                        this.formIsCompleted = false
                    })
                    .finally(() => {
                        // this.result.loading = false
                    })


                }, submitDelay)
            },


            validateConditionalRule(ruleSet, currentfield=null) {
                let isValid = false

                if (!ruleSet.enabled || !ruleSet.rules?.length) return true
                ruleSet.rules.forEach(set => { // or
                    if (isValid) return // exit if already valid else try to validate un next OR rule

                    isValid = true
                    set.forEach(rule => {
                        let field = null

                        if (currentfield && currentfield.repeaterIndex !== null && currentfield.repeaterIndex !== false) {
                            field = this.activeFields.find(item => item.id == rule.target + '-' + currentfield.repeaterIndex)
                        }
                        if (!field) {
                            field = this.activeFields.find(item => item.id == rule.target)
                        }

                        if (!field) {
                            isValid = false
                            return;
                        }

                        let ruleValue = rule.value
                        if (ruleValue !== null && String(ruleValue).trim() != '' && String(ruleValue).startsWith('javascript:')) {
                            try {
                                ruleValue = eval(ruleValue.replace('javascript:', ''))
                            } catch (error) {
                                console.error('Error:', error)
                            }
                        }

                        switch (rule.operator){
                            case 'equal':
                                if (field.value === null || field.value==='' || field.value != ruleValue) isValid = false
                                break
                            case 'notequal':
                                if (field.value === null || field.value==='' || field.value == ruleValue) isValid = false
                                break
                            case 'greaterthan':
                                if (field.value === null || field.value==='' || field.value <= ruleValue) isValid = false
                                break
                            case 'lessthan':
                                if (field.value === null || field.value==='' || field.value >= ruleValue) isValid = false
                                break
                            case 'isset':
                                if (field.value === null || (!Array.isArray(field.value) && String(field.value).trim() == "") || (Array.isArray(field.value) && !field.value.length)) isValid = false
                                break
                            case 'empty':
                                if (field.value !== null && ((!Array.isArray(field.value) && field.value != "") || (Array.isArray(field.value) && field.value.length>0))) isValid = false
                                break
                            case 'contains':
                                if (Array.isArray(field.value)) {
                                    let values = ruleValue.split(',')
                                    values.forEach(value => {
                                        if (!field.value.includes(String(value).trim())) isValid = false
                                    })
                                } else {
                                    if (field.value === null || !String(field.value).includes(ruleValue)) isValid = false
                                }
                                break
                        }
                    })

                })

                return isValid
            },

            setFormValue(event) {
                this.form.sections.forEach(section => {
                    section.fields.forEach(fields => {
                        fields.fieldsList.forEach(field => {
                            if (field.inputName == event.fieldName) {
                                field.value = event.fieldValue
                            }
                        })
                    })
                })
            },

            getFieldByID(fieldID) {

                let foundField = null

                this.form.sections.forEach(section => {
                    section.fields.forEach(fields => {
                        fields.fieldsList.forEach(field => {
                            if (field.id == fieldID) {
                                foundField = field
                            }
                        })
                    })
                })

                return foundField
            },

            getMappedHiddenField(event) {
                this.form.sections.forEach(section => {
                    section.fields.forEach(fields => {
                        fields.fieldsList.forEach(field => {
                            if (field.inputName == event.fieldSearch && field.inputType == 'hidden') {
                                event.field.dependantFields.push(field)
                            }
                        })
                    })
                })
            },

            getStepperSections() {
                this.stepperSections = this.activeSections.filter(section => section.isStep)
            },

            validateForm(currentStep=null) {
                let isValid = true
                let scrollToEl = null
                
                if (currentStep!==null) {
                    let currentSection = this.stepperSections[currentStep]

                    if (this.$refs[currentSection.id][0]?.$el) {
                        this.$refs[currentSection.id][0].$el.querySelectorAll('input, textarea, select').forEach(input => {
                            if (!input.checkValidity()) {
                                isValid = false
                                if (!scrollToEl) scrollToEl = input
                            }
                        })
                    }


                    if (!isValid) {
                        let invalidFields = []
                        this.$refs[currentSection.id][0].$el.querySelectorAll('input:invalid, textarea:invalid, select:invalid').forEach(input => {
                            invalidFields.push(input.id)
                        })
                        this.emitter.emit('set-invalid-fields', invalidFields)
                    }


                    if (isValid && this.useStepper && currentStep + 1 < this.stepperSections.length) {
                        this.form.currentStep++
                    }
                } else {
                    isValid = this.$refs['form-' + this.form.id].checkValidity()
                    if (!isValid) scrollToEl = this.$refs['form-' + this.form.id].querySelector('input:invalid, textarea:invalid, select:invalid')

                    if (!isValid) {
                        let invalidFields = []
                        this.$refs['form-' + this.form.id].querySelectorAll('input:invalid, textarea:invalid, select:invalid').forEach(input => {
                            invalidFields.push(input.id)
                        })
                        this.emitter.emit('set-invalid-fields', invalidFields)
                    }
                }

                if (scrollToEl) {
                    let headerHeight = 0;
                    if (this.$el.querySelector('.c-mobile-stepper__wrap')) headerHeight = headerHeight + this.$el.querySelector('.c-mobile-stepper__wrap').offsetHeight
                    if (document.querySelector('header')) headerHeight = headerHeight + document.querySelector('header').offsetHeight

                    window.locomotiveScroll.scrollTo(scrollToEl, {
                        offset: parseInt('-' + (headerHeight + 60))
                    })
                    scrollToEl.focus()
                }
                if (!isValid) this.$refs['form-' + this.form.id].parentNode.classList.add('is-form-invalid')
                else this.$refs['form-' + this.form.id].parentNode.classList.remove('is-form-invalid')

                return isValid
            }
        },
    }

</script>